import { george, pr, ui } from "aaa";
import { ChooseAccountSelect } from "components/common/ChooseAccount";
import { FormattedHTMLMessage } from "i18n/util";
import { observer } from "mobx-react";
import * as React from "react";
import auth from "stores/AuthStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { amountToCurrencyString } from "types/amount";
import { BSPOptionsStore } from "../BSPOptionsStore";


type IProps = { isAccountSelectable?: boolean; store: BSPOptionsStore, style?: React.CSSProperties };
export const BSPOptionsPayoutSummarySection = observer((
    { isAccountSelectable, store, style }: IProps
) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const summaryElementStyles = isMobile
        ? {
            elementStyle: {
                fontSize: 16,
                lineHeight: "24px"
            },
            labelStyle: {
                fontSize: 14,
                lineHeight: "20px",
            }
        }
        : {
            elementStyle: {
                fontSize: 16,
                lineHeight: "24px",
                width: "50%"
            },
            labelStyle: {
                fontSize: 14,
                lineHeight: "20px",
                width: "50%"
            }
        };

    const summaryElementLabelStyle = {
        alignItems: "center",
        margin: "unset",
        padding: 10,
        borderRadius: 4,
    };

    const summaryElementBackgroundStyle = {
        ...summaryElementLabelStyle,
        backgroundColor: ui.isDarkMode ? "#3A3A3C" : "#EFF1F5",
    };

    const contractHolders = store.payoutInfo?.contractOwners.filter(customer => customer.customerRoleCode === "VI") ?? [];
    const contractAdditionalHolders = store.payoutInfo?.contractOwners.filter(customer => customer.customerRoleCode === "WVI") ?? [];
    const allContractHolders = contractHolders.concat(contractAdditionalHolders);

    const contractHolderLegalGuardians = store.payoutInfo?.contractOwners.filter(customer => customer.customerRoleCode === "GV") ?? [];

    const hasLegalGuardians = contractHolderLegalGuardians.length > 0;

    const expiryDate = store.payoutInfo?.contractExpiryDate ? new Date(store.payoutInfo.contractExpiryDate) : null;
    const localizedExpiryDate = expiryDate ? expiryDate.toLocaleDateString(auth.locale, { day: "numeric", month: "long", year: "numeric" }) : "-";

    const currentBalance = store.buildingsAccount?.balance ? amountToCurrencyString(store.buildingsAccount.balance) : "-";

    return (
        <div style={style}>
            <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                {ui.__("bspOptions.summary.title")}
            </pr.P_18_TITLE>
            <div style={{ marginTop: 8 }}>
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.contractNumber")}
                    style={summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {store.buildingsAccount?.id}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>

                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.contractOwner")}
                    style={summaryElementLabelStyle}
                    {...summaryElementStyles}
                >
                    {allContractHolders.map(contractHolder => (
                        <pr.SigningLabel key={contractHolder.customerId}>
                            {contractHolder?.firstName} {contractHolder?.lastName}
                        </pr.SigningLabel>
                    ))}
                </george.ResponsiveSummaryElement>

                {hasLegalGuardians && (
                    <george.ResponsiveSummaryElement
                        label={ui.__("bspOptions.summary.legalRepresentative")}
                        style={summaryElementBackgroundStyle}
                        {...summaryElementStyles}
                    >
                        {contractHolderLegalGuardians.map(contractHolderLegalGuardian => (
                            <pr.SigningLabel>
                                {contractHolderLegalGuardian?.firstName} {contractHolderLegalGuardian.lastName}
                            </pr.SigningLabel>
                        ))}
                    </george.ResponsiveSummaryElement>
                )}

                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.endDate")}
                    style={hasLegalGuardians ? summaryElementLabelStyle : summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {localizedExpiryDate}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>

                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.currentBalance")}
                    style={hasLegalGuardians ? summaryElementBackgroundStyle : summaryElementLabelStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {currentBalance}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>

                <george.ResponsiveSummaryElement
                    label={<FormattedHTMLMessage id="bspOptions.summary.payoutAccount" />}
                    style={hasLegalGuardians ? summaryElementLabelStyle : summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    {store.accountsStore && isAccountSelectable && <ChooseAccountSelect store={store.accountsStore} />}
                    {!isAccountSelectable && <pr.SigningLabel>{store.accountsStore?.selectedAccount?.description}</pr.SigningLabel>}
                    {!isAccountSelectable && <pr.SigningLabel>{store.accountsStore?.selectedAccount?.accountno.iban}</pr.SigningLabel>}
                </george.ResponsiveSummaryElement>

            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./src/components/BSPOptions/components/BSPOptionsPayoutSummarySection.tsx